import styled from '@emotion/styled'
import { space, color, H1, H3, device } from '@ticketswap/solar'

interface AlignmentProps {
  align?: 'start' | 'center' | 'end'
}

const Container = styled.div<AlignmentProps>`
  margin-block-end: ${space[24]};
  text-align: ${props => props.align};
  margin-block-start: ${space[32]};

  @media ${device.tablet} {
    margin-block-end: ${space[32]};
  }
`

const StyledH1 = styled(H1)<AlignmentProps>`
  transform: ${props => props.align === 'start' && 'translateX(-1px)'};

  @media ${device.tablet} {
    transform: ${props => props.align === 'start' && 'translateX(-2px)'};
  }
`

const StyledH3 = styled(H3)`
  margin-block-start: ${space[16]};
  color: ${color.foregroundMuted};

  strong {
    color: ${color.foreground};
  }

  span {
    a {
      color: ${color.foregroundMuted};
    }
  }
`

interface PageTitleProps {
  primary: string
  secondary?: string
  align?: 'start' | 'center' | 'end'
  className?: string
}

export const PageTitle = ({ primary, secondary, align = 'start', className }: PageTitleProps) => (
  <Container align={align} className={className}>
    <StyledH1 align={align}>{primary}</StyledH1>
    {secondary && <StyledH3>{secondary}</StyledH3>}
  </Container>
)
